import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { useResource } from "@rest-hooks/core";
import { VendorSalespersonResource, LoginResource } from "@ploy-lib/rest-resources";
import { DployAutocomplete } from "@ploy-ui/form-fields";
import { legacyApiResourceUrl } from "@ploy-lib/core";
export const VendorSalespersonSelector = (props) => {
    const { salespersonId, vendorId, applicationId } = props;
    const { vendor: currentVendor } = useResource(LoginResource.status(), {});
    const vendorSalespeople = useResource(VendorSalespersonResource.list(), {
        vendorid: currentVendor?.id
    } || []);
    const [selected, setSelected] = useState(vendorSalespeople.find(x => x.key === `${vendorId}-${salespersonId}`));
    const handleSalespersonChange = (e, value) => {
        setSelected(value ?? undefined);
        if (!value)
            return;
        fetch(legacyApiResourceUrl(`Reassignment.ReassignApplications/ReasignVendorSalesperson`), {
            method: "POST",
            body: new Blob([
                JSON.stringify({
                    salespersonId: value.salepersonId,
                    applicationId: applicationId,
                    vendorId: value.vendorId
                })
            ], {
                type: "application/json"
            }),
            headers: {
                accept: "application/json"
            }
        });
    };
    return (_jsx(DployAutocomplete, { style: { width: 300 }, value: selected, items: vendorSalespeople, onChange: handleSalespersonChange, fullWidth: true, getItemLabel: item => item.name, disableClearable: true }));
};
//# sourceMappingURL=VendorSalespersonSelector.js.map